/* eslint-disable import/no-extraneous-dependencies */

import React from "react";
import PropTypes from "prop-types";
import AsyncSelect from "react-select";

const PMSPicker = ({ pmsTypeV = "", setFieldValue, companyOptions }) => (
  <AsyncSelect
    isClearable
    options={companyOptions}
    placeholder="Choose PMS"
    value={pmsTypeV ? companyOptions.find((company) => company.value === pmsTypeV?.value) : null}
    onChange={(selectedOption) => {
      setFieldValue("pmsType", selectedOption || {});
    }}
    components={{
      DropdownIndicator: () => null,
      IndicatorSeparator: () => null,
    }}
    styles={{
      control: (base, state) => ({
        ...base,
        minHeight: "40px",
        borderColor: state.isFocused ? "#003005" : base.borderColor, // Change border color on focus
        boxShadow: state.isFocused ? "0 0 0 1px #003005" : base.boxShadow, // Optional: Add a shadow for better visual
        "&:hover": {
          borderColor: state.isFocused ? "#003005" : base.borderColor, // Maintain border color on hover
        },
      }),
      input: (base) => ({
        ...base,
        fontSize: "0.875rem",
      }),
      menuList: (base) => ({
        ...base,
        fontSize: "0.875rem",
      }),
      placeholder: (base) => ({
        ...base,
        fontSize: "0.875rem",
      }),
      singleValue: (base) => ({
        ...base,
        fontSize: "0.875rem", // Customize the selected option text size
      }),
    }}
  />
);

// Prop-types for PMSPicker
PMSPicker.propTypes = {
  pmsTypeV: PropTypes.string,
  setFieldValue: PropTypes.func.isRequired,
  companyOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default PMSPicker;
